import _ from 'lodash';
import React from 'react';
import { NavLink, navigateAction } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import CustomerActions from '../../actions/CustomerActions';
import Customer from '../../models/Customer';
import Store from '../../models/Store';
import PaymentMethod from '../PaymentMethod';
import PaymentMethodModal, { Modes as PaymentMethodModalModes } from '../PaymentMethodModal';
import ShippingAddressModal, { Modes as ShippingAddressModalModes } from '../ShippingAddressModal';
import EmailTogglePng from './images/email_toggle.png';
import EmailToggleSvg from './images/email_toggle.svg';
import EmailToggleHightlightPng from './images/email_toggle_highlight.png';
import EmailToggleHightlightSvg from './images/email_toggle_highlight.svg';
import PushTogglePng from './images/push_toggle.png';
import PushToggleSvg from './images/push_toggle.svg';
import PushToggleHightlightPng from './images/push_toggle_highlight.png';
import PushToggleHightlightSvg from './images/push_toggle_highlight.svg';
import styles from './index.sass';

class AccountSettings extends React.Component {
  static propTypes = {
    customer: React.PropTypes.instanceOf(Customer),
    store: React.PropTypes.instanceOf(Store),
    requestStatus: React.PropTypes.string,
    error: React.PropTypes.object
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    buildURLForRoute: React.PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = _.extend(this.getStateFromProps(props), {
      selectedShippingAddressId: null,
      showShippingAddressModal: false,
      showPaymentMethodModal: false,
      shippingAddressModalMode: null
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.customer !== this.props.customer) {
      this.setState(this.getStateFromProps(nextProps));
    }
  }

  getStateFromProps(props) {
    return {
      name: props.customer ? props.customer.name : '',
      email: props.customer ? props.customer.email : '',
      phone: props.customer ? props.customer.phone : '',
      emailToggleButtonDisabled: false
    };
  }

  handleOnClickSignOutLink(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({popoverIsOpen: false});

    let signOutUrl = this.context.buildURLForRoute('signOut');
    this.context.executeAction(navigateAction, {url: signOutUrl});
    return;
  }

  handleOnChangeName(e) {
    this.setState({name: e.target.value});
  }

  handleOnBlurContactInfoField(field, e) {
    let value = this.state[field];
    // Save it
    this.context.executeAction(CustomerActions.updateContactInfo, {
      [field]: value
    });
  }

  handleOnClickNewShippingAddressButton(e) {
    this.setState({
      selectedShippingAddressId: null,
      shippingAddressModalMode: ShippingAddressModalModes.Add,
      showShippingAddressModal: true
    });
  }

  handleOnClickEditShippingAddressButton(shippingAddressId, e) {
    this.setState({
      selectedShippingAddressId: shippingAddressId,
      shippingAddressModalMode: ShippingAddressModalModes.Edit,
      showShippingAddressModal: true
    });
  }

  handleOnClickNewPaymentMethodButton(e) {
    this.setState({
      showPaymentMethodModal: true
    });
  }

  handleOnClickRemovePaymentMethodButton(paymentMethodId, e) {
    this.context.executeAction(CustomerActions.removePaymentMethod, {
      payment_method_id: paymentMethodId
    });
  }

  handleOnCancelShippingAddressModal() {
    this.setState({showShippingAddressModal: false});
  }

  handleOnSaveShippingAddressModal() {
    this.setState({showShippingAddressModal: false});
  }

  handleOnRemoveShippingAddressModal() {
    this.setState({showShippingAddressModal: false});
  }

  handleOnCancelPaymentMethodModal() {
    this.setState({showPaymentMethodModal: false});
  }

  handleOnSavePaymentMethodModal() {
    this.setState({showPaymentMethodModal: false});
  }

  handleOnClickEmailToggleButton(setting, e) {
    this.setState({emailToggleButtonDisabled: true});
    this.context.executeAction(CustomerActions.updateNotificationSettings, {
      store_id: setting.store_id,
      setting_key: setting.setting_key,
      setting_value: !setting.setting_value
    });
  }

  renderShippingAddresses(shippingAddresses) {
    return shippingAddresses.map((address) => {
      let editShippingAddressButtonProps = {
        onClick: this.handleOnClickEditShippingAddressButton.bind(this, address.id)
      };
      return (
        <div className={styles.address} key={address.id}>
          {address.name ? <p>{address.name}</p> : null}
          <p>{address.addr1}</p>
          {address.addr2 ? <p>{address.addr2}</p> : null}
          <p>{address.city}, {address.state} {address.zip_code}</p>
          <button {...editShippingAddressButtonProps}>Edit</button>
        </div>
      );
    });
  }

  renderPaymentMethods(paymentMethods) {
    return paymentMethods.map((paymentMethod) => {
      let paymentMethodProps = {
        paymentMethod: paymentMethod,
        includeLeadingBullets: true
      };
      let removePaymentMethodButtonProps = {
        onClick: this.handleOnClickRemovePaymentMethodButton.bind(this, paymentMethod.id)
      };
      return (
        <div className={styles.paymentMethod} key={paymentMethod.id}>
          <PaymentMethod {...paymentMethodProps} />
          <button {...removePaymentMethodButtonProps}>Remove</button>
        </div>
      );
    });
  }

  renderNotificationSettings(notificationSettings) {
    if(!notificationSettings) {return null;}
    return notificationSettings.map(setting => {
      let buttonProps = {
        onClick: this.handleOnClickEmailToggleButton.bind(this, setting),
        disabled: this.state.emailToggleButtonDisabled
      };
      let imgProps = {
        src: setting.setting_value ? EmailToggleHightlightPng : EmailTogglePng,
        srcSet: setting.setting_value ? EmailToggleHightlightSvg : EmailToggleSvg
      };
      return (
        <div className={styles.notificationSetting} key={setting.store_id}>
          <p>{setting.name}</p>
          <button {...buttonProps}><img {...imgProps} /></button>
        </div>
      );
    });
  }

  renderShippingAddressModal(shippingAddresses) {
    if(!this.state.showShippingAddressModal) {return null;}
    let shippingAddressModalProps = {
      selectedShippingAddressId: this.state.selectedShippingAddressId,
      shippingAddresses: shippingAddresses,
      mode: this.state.shippingAddressModalMode,
      onCancel: this.handleOnCancelShippingAddressModal.bind(this),
      onSave: this.handleOnSaveShippingAddressModal.bind(this),
      onRemove: this.handleOnRemoveShippingAddressModal.bind(this)
    };
    return <ShippingAddressModal {...shippingAddressModalProps} />;
  }

  renderPaymentMethodModal(paymentMethods) {
    if(!this.state.showPaymentMethodModal) {return null;}
    let paymentMethodModalProps = {
      paymentMethods: paymentMethods,
      customer: this.props.customer,
      mode: PaymentMethodModalModes.Add,
      onCancel: this.handleOnCancelPaymentMethodModal.bind(this),
      onSave: this.handleOnSavePaymentMethodModal.bind(this)
    };
    return <PaymentMethodModal {...paymentMethodModalProps} />;
  }

  renderError() {
    if(!this.props.error) {return null;}
    return <p className={styles.error}>{this.props.error.user_message || this.props.error.message}</p>;
  }

  render() {
    let { customer, store } = this.props;
    let { name, email, phone } = this.state;
    let nameInputProps = {
      type: 'text',
      autoComplete: 'name',
      placeholder: 'Full name',
      value: name,
      onChange: this.handleOnChangeName.bind(this),
      onBlur: this.handleOnBlurContactInfoField.bind(this, 'name')
    };
    let emailInputProps = {
      type: 'email',
      autoComplete: 'email',
      placeholder: 'Email address',
      value: email,
      disabled: !!this.props.customer.email,
      onChange: this.handleOnChangeName.bind(this),
      onBlur: this.handleOnBlurContactInfoField.bind(this, 'email')
    };
    let signOutLinkProps = {
      href: this.context.buildURLForRoute('signOut'),
      onClick: this.handleOnClickSignOutLink.bind(this)
    };
    let newShippingAddressButtonProps = {
      className: styles.newShippingAddressButton,
      onClick: this.handleOnClickNewShippingAddressButton.bind(this)
    };
    let newPaymentMethodButtonProps = {
      className: styles.newPaymentMethodButton,
      onClick: this.handleOnClickNewPaymentMethodButton.bind(this)
    };

    return (
      <div className={styles.accountSettings}>
        <h3>Account</h3>
        {this.renderError()}
        <input {...nameInputProps} />
        <input {...emailInputProps} />
        <p className={styles.signOut}>Not you? <NavLink {...signOutLinkProps}>Sign out</NavLink>.</p>
        <h3>Shipping address</h3>
        <div>{this.renderShippingAddresses(customer.shipping_addresses)}</div>
        <button {...newShippingAddressButtonProps}>Enter new shipping address</button>
        <h3>Payment</h3>
        <div>{this.renderPaymentMethods(customer.payment_methods)}</div>
        <button {...newPaymentMethodButtonProps}>Enter new payment method</button>
        {customer.notification_settings.length ? <h3>Notifications</h3> : null}
        <div>{this.renderNotificationSettings(customer.notification_settings)}</div>
        {this.renderShippingAddressModal(customer.shipping_addresses)}
        {this.renderPaymentMethodModal(customer.payment_methods)}
      </div>
    );
  }
}

export default AccountSettings;



// WEBPACK FOOTER //
// banquet/components/AccountSettings/index.js